
import { 
  SidebarHeader as UIHeader,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import Logo from "../navigation/Logo";

export function SidebarHeader() {
  return (
    <UIHeader className="py-6 px-4">
      <div className="flex items-center space-x-2">
        <Logo isAuthenticated={true} />
        <SidebarTrigger />
      </div>
    </UIHeader>
  );
}
